<div [hidden]="hiddenHTML()">
  <form autocomplete="off" #renewForm="ngForm" class="uk-margin-small-bottom uk-text-left" novalidate>
    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_first()">
      <!-- <div style="margin-bottom: 85px;"> -->
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body" style="padding-bottom: 0px;">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <circle-progress [percent]="20.00" [radius]="30" [space]="-10" [outerStrokeGradient]="true"
                    [outerStrokeWidth]="10" [outerStrokeColor]="style.Circle"
                    [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="10"
                    [title]="'1/5'" [titleFontWeight]="600" [titleFontSize]="17" [showUnits]="false"
                    [showSubtitle]="false"></circle-progress>
                </div>
                <div style="padding: 30px 0px 0px 0px">
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">เลือกผลิตภัณฑ์ประกันภัย</label>
                  <br />
                  <label class="uk-form-label" style="font-size: 0.7rem !important; float: right;">ถัดไป :
                    ข้อมูลส่วนตัว</label>
                  <br />
                </div>
              </div>

              <div style="padding: 10px 0px 0px 0px;">
                <div>
                  <label class="uk-form-label" style="font-size: 1.3rem !important; font-style: oblique;"
                    [ngStyle]="{'color': style.Circle}">เลือกผลิตภัณฑ์ประกันภัย</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-container uk-container-xsmall" style="padding: 10px 31px 10px 31px;"
        [ngStyle]="{'background-color': style.BG}">
        <div style="margin-top: 0px !important" uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label" style="font-size: 0.7rem !important;"
              [ngStyle]="{'color': style.Text}">ผู้เอาประกันภัย</label>
          </div>
          <div class="uk-width-expand">
            <label class="uk-form-label" style="font-size: 0.7rem !important; word-wrap: break-word; float: right;"
              [ngStyle]="{'color': style.Text}">หมายเลขอ้างอิง : {{insuredetail_data.refNo2 || ''}}</label>
          </div>
        </div>
        <div>
          <label class="uk-form-label" style="font-size: 1.3rem !important; font-style: oblique;"
            [ngStyle]="{'color': style.Text}">{{insuredetail_data.name ||
            ''}}</label>
        </div>
        <br>
        <div style="margin-top: 0px !important" uk-grid>
          <div class="uk-width-auto">
            <label class="uk-form-label" style="font-size: 1.0rem !important; font-style: oblique;"
              [ngStyle]="{'color': style.Text}">ค่าเบี้ยประกันภัยรวม</label>
          </div>
          <div class="uk-width-expand">
            <label class="uk-form-label"
              style="font-size: 1.0rem !important; word-wrap: break-word; font-style: oblique; float: right;"
              [ngStyle]="{'color': style.Text}">{{numberWithCommas(total_amount())}} บาท</label>
          </div>
        </div>
      </div>
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body">
              <div style="padding: 0px 0px 0px 0px;">
                <div uk-grid>
                  <div class="uk-width-auto uk-text-center">
                    <img src="images/{{insuredetail_data.logoOfferInsureBrand}}"
                      style="height:80px; float: left; padding: 5px;">
                  </div>

                  <div class="uk-width-expand" style="padding: 0px;">
                    <div style="margin: 0px; padding: 0px;">
                      <label class="uk-form-label"
                        style="font-size: 1.1rem !important; font-weight:bold;">{{insuredetail_data.offerInsureType}}</label>
                    </div>
                    <div *ngIf="!isCompulsory()" class="uk-child-width-1-2" style="margin: 0px !important" uk-grid>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label" style="font-size: 0.8rem !important;">ทุนประกัน</label>
                      </div>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label"
                          style="font-size: 0.8rem !important; word-wrap: break-word;">{{numberWithCommas(insuredetail_data.offerInsureFund)}}
                          บาท</label>
                      </div>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label" style="font-size: 0.8rem !important;">เบี้ยประกัน</label>
                      </div>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label"
                          style="font-size: 0.8rem !important; word-wrap: break-word;">{{numberWithCommas(insuredetail_data.offerInsureAmount)}}
                          บาท</label>
                      </div>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label" style="font-size: 0.8rem !important;">การจัดซ่อม</label>
                      </div>
                      <div style="margin: 0px; padding: 0px; height: 1.2rem;">
                        <label class="uk-form-label"
                          style="font-size: 0.8rem !important; word-wrap: break-word;">{{insuredetail_data.offerInsureClaim}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="padding: 20px 0px 0px 0px;" *ngIf="insuredetail_data.additionalProduct.length > 0">
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; font-style: oblique;">เลือกผลิตภัณฑ์ประกันภัยที่ต้องการต่ออายุ</label>
                </div>
                <div style="padding: 10px 10px 10px 10px;">
                  <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid" style="margin: 0px;">
                    <label style="padding: 0px;"><input class="uk-checkbox" style="border-radius: 20%;" type="checkbox"
                        (click)="clickCheckAllAdditionalOption()" [checked]="additional_check_all()">
                      เลือกผลิตภัณฑ์ทั้งหมด</label>
                  </div>
                </div>
              </div>

              <div *ngFor="let data of insuredetail_data.additionalProduct; let i = index"
                style="margin: 5px 0px 5px 0px;">
                <div (click)="clickAdditionalOption(i)"
                  style="padding: 5px 0px 5px 0px; border: 2px solid; border-color:lightgrey; border-radius: 5px;">
                  <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid" style="margin: 0px;">
                    <label style="padding: 10px; font-size: 0.8rem;">
                      <input class="uk-checkbox" type="checkbox" style="border-radius: 20%;"
                        [checked]="additional_option()[i]">
                      <a (click)="clickAdditionalOption(i)" style="color: #666;">
                        <img src="{{image_url(data)}}" style="height: 2.5rem; padding: 0px 5px 0px 5px">
                        {{data.product_name}} {{numberWithCommas(data.value)}} บาท
                      </a>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="insuredetail_data.additionalProduct.length > 0 && !isCompulsory()"
        style="padding: 10px 10px 10px 10px; background-color: #f4f4f4; line-height: 17px; margin: 20px 31px 10px 31px;">
        <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
          สำหรับการเลือกเพิ่ม/ลดแผนประกันภัย
        </label>
        <br>
        <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
          - ค่าเบี้ยประกันภัยรวมจะเปลี่ยนแปลงตามผลิตภัณฑ์ประกันภัยที่ท่านเลือก
        </label>
        <br>
        <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
          สำหรับการเพิ่มอุปกรณ์ตกแต่ง
        </label>
        <br>
        <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">
          - ทุนประกันภัยอาจมีการเปลี่ยนแปลง เจ้าหน้าที่จะติดต่อท่านเพื่อแจ้งค่าเบี้ยประกันภัยรวมอีกครั้งโดยด่วน
        </label>
      </div>
      <div style="padding: 5px 31px 0 31px;">
        <button type="submit"
          class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
          style="width: 100%; margin: 0px !important; padding: 0px 0px 0px 0px;"
          [ngStyle]="{'background-color': style.Button}" (click)="onNextToSecond()">ถัดไป
        </button>
      </div>
      <!-- </div> -->
      <!-- <div class="footer">
        <div style="padding: 5px 31px 50px 31px;">
          <button type="submit"
            class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
            style="width: 100%; margin: 0px !important; padding: 0px 0px 0px 0px;"
            [ngStyle]="{'background-color': style.Button}" (click)="onNextToSecond()">ถัดไป
          </button>
        </div>
      </div> -->
    </section>

    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_second()">
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <circle-progress [percent]="40.00" [radius]="30" [space]="-10" [outerStrokeGradient]="true"
                    [outerStrokeWidth]="10" [outerStrokeColor]="style.Circle"
                    [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="10"
                    [title]="'2/5'" [titleFontWeight]="600" [titleFontSize]="17" [showUnits]="false"
                    [showSubtitle]="false"></circle-progress>
                </div>
                <div style="padding-top: 30px">
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">ข้อมูลส่วนตัว</label>
                  <br />
                  <label class="uk-form-label" style="font-size: 0.7rem !important; float: right;">ถัดไป :
                    ข้อมูลรถปัจจุบัน</label>
                  <br />
                </div>
              </div>
              <div class="hline"></div>
              <div style="padding: 10px 20px 20px 20px; background-color: #f4f4f4;">
                <div>
                  <label class="uk-form-label" style="font-size: 0.7rem !important">หมายเลขอ้างอิง :
                    {{insuredetail_data.refNo2 || ''}}</label>
                </div>
                <br />
                <div class="uk-child-width-1-2" style="margin-top: 15px !important" uk-grid>
                  <div>
                    <label class="uk-form-label" style="font-size: 0.9rem !important">ชื่อ - นามสกุล</label>
                  </div>
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.9rem !important; word-wrap: break-word;">{{insuredetail_data.name ||
                      ''}}</label>
                  </div>
                </div>
                <div class="hline"></div>
                <div class="uk-child-width-1-2" style="margin-top: 15px !important" uk-grid>
                  <div>
                    <label class="uk-form-label" style="font-size: 0.9rem !important">ยี่ห้อ</label>
                  </div>
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.9rem !important; word-wrap: break-word;">{{insuredetail_data.carBrand ||
                      ''}}</label>
                  </div>
                </div>
                <div class="hline"></div>
                <div class="uk-child-width-1-2" style="margin-top: 15px !important" uk-grid>
                  <div>
                    <label class="uk-form-label" style="font-size: 0.9rem !important">ปีรถ</label>
                  </div>
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.9rem !important; word-wrap: break-word;">{{insuredetail_data.carYear ||
                      ''}}</label>
                  </div>
                </div>
                <div class="hline"></div>
                <div class="uk-child-width-1-2" style="margin-top: 15px !important" uk-grid>
                  <div>
                    <label class="uk-form-label" style="font-size: 0.9rem !important">เลขทะเบียน</label>
                  </div>
                  <div *ngIf="editCarNo()">
                    <input id="car_no" #car_no="ngModel" name="car_no" class="uk-input uk-border-rounded"
                      placeholder="เลขทะเบียน" type="text" [(ngModel)]="carNo"
                      (change)="onChangeCarNo($event.target.value)" autocomplete="off"
                      [ngClass]="addClass(renewForm,'car_no')">
                    <!-- <small class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                        tabindex="-1" [ngClass]="addClass(renewForm,'car_no','msg')">
                        <span *ngIf="car_no.errors&& car_no.errors.required">กรุณาระบุเลขทะเบียน</span>
                    </small> -->
                  </div>
                  <div *ngIf="!editCarNo()">
                    <label class="uk-form-label"
                      style="font-size: 0.9rem !important; word-wrap: break-word;">{{insuredetail_data.carNo ||
                      ''}}<span uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                        *ngIf="!editData()" (click)="onEditCarNo()"></span></label>
                  </div>
                </div>
                <div class="hline"></div>
                <div class="uk-child-width-1-2" style="margin-top: 15px !important" uk-grid>
                  <div>
                    <label class="uk-form-label" style="font-size: 0.9rem !important">จังหวัดที่จดทะเบียน</label>
                  </div>
                  <div *ngIf="editData()">
                    <div class="uk-form-controls uk-position-relative">
                      <select id="province" #province="ngModel" name="province" class="uk-select uk-border-rounded"
                        [(ngModel)]="editProvince" (change)="onSelectProvince($event)">
                        <option [value]="''"></option>
                        <option *ngFor="let data of insuredetail_data.province" [value]="data.value">{{data.detail}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div *ngIf="!editData()">
                    <label class="uk-form-label" style="font-size: 0.9rem !important; word-wrap: break-word;"
                      *ngIf="insuredetail_data.carProvince">{{onShowProvinceName(insuredetail_data.carProvince) ||
                      ''}}<span uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                        *ngIf="!editCarNo()" (click)="onEditData()"></span></label>
                    <label class="uk-form-label" style="font-size: 0.9rem !important; word-wrap: break-word;"
                      *ngIf="!insuredetail_data.carProvince"><span uk-icon="file-edit"
                        style="float: right; cursor: pointer; color: #3fbfb9;" *ngIf="!editCarNo()"
                        (click)="onEditData()"></span></label>
                  </div>
                </div>
                <span *ngIf="checkDisabled() && !editData()" class="uk-text-danger" style="font-size: 0.9rem !important;">กรุณากรอกจังหวัดที่จดทะเบียน</span>
              </div>
              <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                *ngIf="!editData() && !editCarNo()">
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                  style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;background-color: white !important; border: 1px solid;"
                  [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onBackToFirst()">ย้อนกลับ
                </button>
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                  style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                  [ngStyle]="{'background-color': style.Button}" (click)="onNextToThird()" [disabled]="checkDisabled()">ถัดไป
                </button>
              </div>
              <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                style="padding-top: 0px; margin-top: 10px;" *ngIf="editData()">
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                  style="min-width: 140px !important; background-color: white;"
                  [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onCancelEditData()">ยกเลิก
                </button>
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                  style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                  (click)="onSaveData()">บันทึก
                </button>
              </div>
              <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                style="padding-top: 0px; margin-top: 10px;" *ngIf="editCarNo()">
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                  style="min-width: 140px !important; background-color: white;"
                  [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onCancelEditCarNo()">ยกเลิก
                </button>
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                  style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                  (click)="onSaveCarNo()" [disabled]="renewForm.invalid">บันทึก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_third()">
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <circle-progress [percent]="60.00" [radius]="30" [space]="-10" [outerStrokeGradient]="true"
                    [outerStrokeWidth]="10" [outerStrokeColor]="style.Circle"
                    [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="10"
                    [title]="'3/5'" [titleFontWeight]="600" [titleFontSize]="17" [showUnits]="false"
                    [showSubtitle]="false"></circle-progress>
                </div>
                <div style="padding-top: 30px">
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">ข้อมูลรถปัจจุบัน</label>
                  <br />
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; float: right; font-style: italic">ถัดไป :
                    ที่อยู่จัดส่งเอกสาร</label>
                  <br />
                </div>
              </div>
              <div class="hline"></div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 1rem !important; font-weight: bold; font-style: italic">ข้อมูลรถปัจจุบัน <span
                    style="font-size: 0.7rem !important; font-weight: lighter; font-style: normal">(กรมธรรม์เดิม)</span></label>
                <br />
                <br />
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.9rem !important; font-weight: bold; font-style: italic">ลักษณะการใช้งานรถยนต์ปัจจุบันของท่าน</label>
                <br />
              </div>
              <div class="uk-form-controls uk-position-relative">
                <select id="car_usage" #car_usage="ngModel" name="car_usage" class="uk-select uk-border-rounded"
                  [(ngModel)]="insuredetail_data.carUsage" (change)="onEditCarUsage($event)">
                  <option *ngFor="let data of insuredetail_data.motorAction" [value]="data.value">{{data.detail}}
                  </option>
                  <!-- <option *ngFor="let v of test1" [value]="v.testid">{{v.testname}} -->
                </select>
                <small hidden class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error"
                  tabindex="-1">กรุณาเลือกลักษณะการใช้งานรถยนต์ปัจจุบันของท่าน</small>
              </div>
              <div *ngIf="!isCompulsory()">
                <label class="uk-form-label"
                  style="font-size: 0.9rem !important; font-weight: bold; font-style: italic">ปัจจุบันท่านมีอุปกรณ์ตกแต่งรถยนต์</label>
                <br />
              </div>
              <!-- <div>         
                <label class="uk-form-label" style="font-size: 0.7rem !important; font-weight: bold">อุปกรณ์ตกแต่ง<span uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;" (click)="onEdit()"></span></label>
                <br/>
              </div> -->
              <div *ngIf="!editDecoration() && !isCompulsory()">
                <!-- <div *ngFor="let data of insuredetail_data.decoration; let i = index"> -->
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">อุปกรณ์ตกแต่ง
                      <!-- <span uk-icon="minus-circle"
                        style="float: right; cursor: pointer; color: red; margin-left: 10px;"
                        (click)="onDeleteDecoration()"></span> -->
                        <span uk-icon="file-edit"
                        style="float: right; cursor: pointer; color: #3fbfb9;"
                        (click)="onEditDecoration()"></span></label>
                    <br />
                  </div>
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">
                      {{insuredetail_data.decoration[0]}}
                    </label>
                  </div>
                  <div style="padding: 0px 10px 0px 10px; background-color: #f4f4f4;">
                    <label class="uk-form-label"
                      style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">*
                      ท่านสามารถแก้ไข หรือเพิ่มเติมอุปกรณ์ตกแต่งรถยนต์ได้</label>
                  </div>
                <!-- </div> -->
              </div>
              <div *ngIf="editDecoration() && !isCompulsory()">
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">อุปกรณ์ตกแต่ง</label>
                  <br />
                </div>
                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <textarea id="decoration_detail" #decoration_detail="ngModel" name="decoration_detail"
                      class="uk-input uk-border-rounded"
                      style="font-size: 0.8rem !important; height: 100px; line-height: 25px !important;"
                      placeholder="ระบุอุปกรณ์ตกแต่ง" [(ngModel)]="decorationdetail"
                      (change)="onInputDecorationDetail($event)" [ngClass]="addClass(renewForm,'decoration_detail')"
                      required></textarea>
                  </div>
                  <br />
                </div>
                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                  style="padding-top: 0px; margin-top: 10px;">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; background-color: white;"
                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                    (click)="onCancelAddDecoration()">ยกเลิก
                  </button>
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                    (click)="onSaveDecoration()" [disabled]="renewForm.invalid">บันทึก
                  </button>
                  <br />
                </div>
              </div>
              <div *ngIf="!isCompulsory()" class="hline"></div>
              <!-- <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal" style="padding-top: 0px;"
                *ngIf="!addDecoration && !editDecoration">
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                  style="min-width: 300px !important; background-color: white;"
                  [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onAddDecoration()"><span
                    uk-icon="plus-circle"></span> อุปกรณ์ตกแต่ง
                </button>
              </div> -->
              <!-- <div>         
                <label class="uk-form-label" style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{test1}}</label>
                <br/>
                <br/>
              </div>
              <div>
                <textarea class="uk-input uk-border-rounded" style="font-size: 0.8rem !important; height: 100px; line-height: 25px !important;">{{test1}}</textarea>
                <br/>
                <br/>
              </div>          -->
              <div *ngIf="!isCompulsory()">
                <label class="uk-form-label"
                  style="font-size: 0.9rem !important; font-weight: bold; font-style: italic">ประวัติแจ้งเคลม</label>
                <br />
              </div>
              <div *ngIf="!editClaim() && !isCompulsory()">
                <!-- <div *ngIf="!editClaim"> -->
                <div *ngFor="let data of insuredetail_data.claim; let i = index">
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">การแจ้งเคลมลำดับที่
                      {{i+1}}<span uk-icon="minus-circle" *ngIf="data.status=='new'"
                        style="float: right; cursor: pointer; color: red; margin-left: 10px;"
                        (click)="onDeleteClaim(i)"></span><span uk-icon="file-edit"
                        *ngIf="!addClaim() && data.status=='new'" style="float: right; cursor: pointer; color: #3fbfb9;"
                        (click)="onEditClaim(i)"></span></label>
                    <br />
                  </div>
                  <div>
                    <label class="uk-form-label"
                      style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{data.detail}}<span
                        style="float: right">{{data.value}}</span></label>
                  </div>
                  <div *ngIf="!isCompulsory()" class="hline"></div>
                </div>
              </div>
              <div *ngIf="editClaim() && !isCompulsory()">
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">การแจ้งเคลมลำดับที่
                    {{claimIndex+1}}</label>
                  <br />
                </div>
                <textarea id="claim_detail_edit" #claim_detail_edit="ngModel" name="claim_detail_edit"
                  class="uk-input uk-border-rounded"
                  style="font-size: 0.8rem !important; height: 100px; line-height: 25px !important;"
                  placeholder="ประวัติการแจ้งเคลม" [(ngModel)]="claimdetailEdit"
                  (change)="onInputClaimDetailEdit($event)" [ngClass]="addClass(renewForm,'claim_detail_edit')"
                  required></textarea>
                <div class="uk-form-row uk-form-controls uk-position-relative" style="margin-top: 10px;">
                  <div class="uk-inline" style="display: inline;">
                    <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                    <input type="text" class="uk-input ngx-daterangepicker-action uk-border-rounded"
                      (click)="openDatepicker()" placeholder="วัน/เดือน/ปี" mask="d0/M0/0000"
                      [specialCharacters]="['/']" [dropSpecialCharacters]="false" name="claim_value_edit" required
                      [(ngModel)]="claimvalueEdit" #claim_value_edit="ngModel" (change)="onInputClaimValueEdit($event)"
                      [ngClass]="claimValueClassEdit() === 'uk-form-danger' ? 'uk-form-danger' : addClass(renewForm,'claim_value_edit')"
                      (keyup)="checkDateFormat($event)">
                  </div>
                  <input type="text" class="uk-input uk-hidden" ngxDaterangepickerMd #pickerDirective
                    [singleDatePicker]="true" [isCustomDate]="isCustomDate" [locale]="locale" [autoApply]="true"
                    opens="right" [maxDate]="limitdate" drops="up" [linkedCalendars]="true"
                    [(ngModel)]="datepickerSelected" [ngModelOptions]="{standalone:true}"
                    (datesUpdated)="onInputClaimValueEdit($event)">
                </div>
                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                  style="padding-top: 0px; margin-top: 10px;">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; background-color: white;"
                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                    (click)="onCancelAddClaim()">ยกเลิก
                  </button>
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                    (click)="onSaveClaim(claimIndex)"
                    [disabled]="renewForm.invalid || claimValueClassEdit() ==='uk-form-danger'">บันทึก
                  </button>
                </div>
              </div>

              <div *ngIf="addClaim() && !isCompulsory()">
                <!-- <div *ngIf="addClaim" [hidden]="!addClaim"> -->
                <div>
                  <!-- <label class="uk-form-label" style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">การแจ้งเคลมลำดับที่ 2<span uk-icon="minus-circle" style="float: right; cursor: pointer; color: red;" (click)="onEdit()"></span></label> -->
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">การแจ้งเคลมลำดับที่
                    {{insuredetail_data.claim.length+1}}</label>
                  <br />
                </div>
                <div>
                  <textarea id="claim_detail" #claim_detail="ngModel" name="claim_detail"
                    class="uk-input uk-border-rounded"
                    style="font-size: 0.8rem !important; height: 100px; line-height: 25px !important;"
                    placeholder="ประวัติการแจ้งเคลม" [(ngModel)]="claimdetail" (change)="onInputClaimDetail($event)"
                    [ngClass]="addClass(renewForm,'claim_detail')" required></textarea>
                </div>
                <div class="uk-form-row uk-form-controls uk-position-relative" style="margin-top: 10px;">
                  <div class="uk-inline" style="display: inline;">
                    <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
                    <input type="text" class="uk-input ngx-daterangepicker-action uk-border-rounded"
                      (click)="openDatepicker()" placeholder="วัน/เดือน/ปี" mask="d0/M0/0000"
                      [specialCharacters]="['/']" [dropSpecialCharacters]="false" name="claim_value" required
                      [(ngModel)]="claimvalue" #claim_value="ngModel" (change)="onInputClaimValue($event)"
                      [ngClass]="claimValueClass() === 'uk-form-danger' ? 'uk-form-danger' : addClass(renewForm,'claim_value')"
                      (keyup)="checkDateFormat($event)">
                  </div>
                  <input type="text" class="uk-input uk-hidden" ngxDaterangepickerMd #pickerDirective
                    [singleDatePicker]="true" [isCustomDate]="isCustomDate" [locale]="locale" [autoApply]="true"
                    opens="right" [maxDate]="limitdate" drops="up" [linkedCalendars]="true"
                    [(ngModel)]="datepickerSelected" [ngModelOptions]="{standalone:true}"
                    (datesUpdated)="onInputClaimValue($event)">
                </div>
                <div style="padding: 0px 10px 0px 10px; background-color: #f4f4f4; line-height: 17px;">
                  <label class="uk-form-label"
                    style="font-size: 0.5rem !important; color: red; word-wrap: break-word;">*
                    ค่าเบี้ยประกันอาจเปลี่ยนแปลง หากท่านมีการเรียกร้องค่าสินไหมทดแทนในระหว่างกรมธรรม์เดิมยังไม่สิ้นสุด
                    (ข้อมูลการเรียกร้องสินไหมถึง ณ <span style="font-weight: bold; font-style: italic;">วันที่
                      {{expiredate}}</span>)</label>
                </div>
                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                  style="padding-top: 0px; margin-top: 10px;">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; background-color: white;"
                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}"
                    (click)="onCancelAddClaim()">ยกเลิก
                  </button>
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                    (click)="onSaveClaim(9999)"
                    [disabled]="renewForm.invalid || claimValueClass() === 'uk-form-danger'">บันทึก
                  </button>
                </div>
              </div>
              <div>

              </div>
              <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal" style="padding-top: 0px;"
                *ngIf="!addClaim() && !editClaim() && !isCompulsory()">
                <!-- <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal" style="padding-top: 0px;"
                *ngIf="!addClaim && !editClaim"  [hidden]="addClaim && editClaim"> -->
                <button type="submit"
                  class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                  style="min-width: 300px !important; background-color: white;"
                  [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onAddClaim()"><span
                    uk-icon="plus-circle"></span> ประวัติการแจ้งเคลม
                </button>
              </div>

              <div *ngIf="!isCompulsory()" style="padding: 0px 10px 0px 10px; background-color: #f4f4f4; line-height: 17px;">
                <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">*
                  โปรดตรวจสอบข้อมูลของท่านให้เรียบร้อยก่อนยืนยันข้อมูล
                  เพราะท่านจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก</label>
              </div>
            </div>

            <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
              <button type="submit"
                class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px; background-color: white !important; border: 1px solid"
                [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onNextToSecond()">ย้อนกลับ
              </button>
              <button type="submit"
                class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                [ngStyle]="{'background-color': style.Button}" [disabled]="renewForm.invalid"
                (click)="onNextToFourth()">ถัดไป
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_fourth()">
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body" style="padding-bottom: 0px; height: 90vh;">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <circle-progress [percent]="80.00" [radius]="30" [space]="-10" [outerStrokeGradient]="true"
                    [outerStrokeWidth]="10" [outerStrokeColor]="style.Circle"
                    [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="10"
                    [title]="'4/5'" [titleFontWeight]="600" [titleFontSize]="17" [showUnits]="false"
                    [showSubtitle]="false"></circle-progress>
                </div>
                <div style="padding: 30px 0px 0px 0px">
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">เลือกผลิตภัณฑ์ประกันภัย</label>
                  <br />
                  <label class="uk-form-label" style="font-size: 0.7rem !important; float: right;">ถัดไป :
                    ที่อยู่จัดส่งเอกสาร</label>
                  <br />
                </div>
              </div>

              <div style="padding: 10px 0px 10px 0px;">
                <div>
                  <label class="uk-form-label" style="font-size: 1.3rem !important; font-style: oblique;"
                    [ngStyle]="{'color': style.Circle}">เลือกวิธีการชำระเงิน</label>
                </div>
              </div>

              <div
                style="padding: 10px 0px 10px 0px; margin: 10px 0px 0px 0px; border: 2px solid; border-color:lightgrey; border-radius: 5px;">
                <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid" style="margin: 0px;">
                  <label style="padding: 10px; font-size: 0.8rem;">
                    <div style="align-items: center;" uk-grid>
                      <div class="uk-width-auto">
                        <input class="uk-checkbox" type="checkbox" style="border-radius: 20%;"
                          (click)="onClickFullPay()" [disabled]="!installmentStatus()" [checked]="checkBoxFullPay()">
                      </div>
                      <div class="uk-width-expand" style="padding: 0px 0px 0px 10px;">
                        <div style="margin:0px;" uk-grid>
                          <div class="uk-width-auto" style="margin: 0px; padding: 0px;"> ชำระงวดเดียว</div>
                          <div class="uk-width-expand" style="margin: 0px;">{{numberWithCommas(total_amount())}} บาท</div>
                        </div>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div *ngIf="installmentStatus()" uk-grid>
                <div class="uk-width-expand">
                  <div
                    style="padding: 0px 0px 0px 0px; margin: 10px 0px 10px 0px; border: 2px solid; border-color:lightgrey; border-radius: 5px;">
                    <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid" style="margin: 0px;">
                      <label style="padding: 10px; font-size: 0.8rem;">
                        <div style="align-items: center;" uk-grid>
                          <div class="uk-width-auto">
                            <input class="uk-checkbox" type="checkbox" style="border-radius: 20%;"
                              (click)="onClickInstallment()" [checked]="checkBokInstallment()">
                          </div>
                          <div class="uk-width-expand" style="padding: 0px 0px 0px 10px;">
                            <div style="margin:0px;" uk-grid>
                              <div class="uk-width-auto" style="margin: 0px; padding: 0px;"> ผ่อนชำระ
                                {{installmentData().length}} งวด</div>
                              <div class="uk-width-auto" style="margin: 0px; padding: 0px 0px 0px 10px;">งวดที่ 1</div>
                              <div class="uk-width-expand" style="margin: 0px; padding: 0px 0px 0px 10px;">
                                {{numberWithCommas(installmentData()[0].value)}} บาท</div>
                            </div>
                            <p style="color: red; font-size: 0.7rem; margin: 0px;">
                              *สามารถดูตารางผ่อนชำระโดยกดปุ่มด้านข้าง
                              <br>
                              *ยอดนี้ต้องชำระก่อนวันที่ {{convertDateThai(installmentData()[0].date)}} เท่านั้น
                            </p>
                          </div>
                        </div>
                      </label>
                      <div style="padding: 10px 10px 0px 5px ; width: 60 px; margin-left: auto;">
                        <!-- <span uk-icon="info" style="color: black; size: 50px;"></span> -->
                        <span uk-icon="info" class="tooltip" style="size: 50px; color:black; cursor: pointer;">
                          <div class="tooltiptext tooltip-position1" style="line-height: 0.9rem;">
                            <div>
                              <img src="https://services.tiscoinsure.com/contents/images/Header-TISCO-Insure.png"
                                style="width: 100%;">
                              <label class="uk-form-label"
                                style="font-size: 0.8rem !important; font-weight: bold; white-space: nowrap; position: absolute; color:white; right: 155px; padding-top: 10px;">แบ่งชำระรายเดือน</label>
                            </div>
                            <div uk-grid>
                              <div class="uk-width-1-1"
                                style="font-size: 1.0rem; font-weight: bold; margin: 10px 0px 10px 0px;">
                                {{installmentData().length}} เดือน
                                <hr style="margin-top: 10px;">
                              </div>
      
                              <div class="uk-width-1-2" style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">ยอดชำระต่อเดือน
                              </div>
                              <div class="uk-width-1-2"
                                style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                {{numberWithCommas(installmentData()[0].value)}} บาท</div>
                              <div class="uk-width-1-2" style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">วันชำระเงินงวดแรก
                              </div>
                              <div class="uk-width-1-2"
                                style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                {{convertDateThai(installmentData()[0].date)}} </div>
      
                              <div class="uk-width-1-1" *ngFor="let data of installmentData(); let i = index"
                                style="margin: 0px;">
                                <div style="margin: 0px;" *ngIf="i != 0">
                                  <hr style="margin: 5px 0px 5px 0px;">
                                  <div uk-grid>
                                    <div class="uk-width-auto" style="font-size: 0.7rem; margin: 5px 0px 5px 0px;">
                                      ชำระงวดที่ {{i+1}} - {{convertDateThai(data.date)}}
                                    </div>
                                    <div class="uk-width-expand"
                                      style="font-size: 0.7rem; font-weight: bold; margin: 5px 0px 5px 0px; text-align: right;">
                                      {{numberWithCommas(data.value)}} บาท
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div style="position: fixed; bottom: 30px; right: 30px; left: 30px; ">
                <div *ngIf="!isCompulsory()" style="padding: 10px 0px 10px 20px; font-size: 0.7rem; color: red; background-color: #f4f4f4;">
                  * ถ้าไม่ชำระก่อนวันที่แจ้งเบี้ยอาจมีการเปลี่ยนแปลง
                </div>
                <div *ngIf="!isCompulsory()" style="padding: 0px 0px 10px 20px; font-size: 0.7rem; color: red; background-color: #f4f4f4;">
                  * กรณีท่านผ่อนชำระค่าเบี้ยประกันภัยโดยรูปแบบบัตรเครดิต เจ้าหน้าที่จะทำการติดต่อท่านอีกครั้งเพื่อขอข้อมูลบัตรเครดิตในการดำเนินการตัดชำระค่าเบี้ยประกันสำหรับงวดถัดไป
                </div>
                <div *ngIf="!isCompulsory()" class="hline"></div>
                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                    style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;background-color: white !important; border: 1px solid"
                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onNextToThird()">ย้อนกลับ
                  </button>
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                    style="width: 100%; margin: 0px !important; padding: 0px 0px 0px 0px;"
                    [ngStyle]="{'background-color': style.Button}" (click)="onNextToFifth()">ถัดไป
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_fifth() && !editAddr()">
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small">
            <div class="uk-card uk uk-card-body">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <circle-progress [percent]="100" [radius]="30" [space]="-10" [outerStrokeGradient]="true"
                    [outerStrokeWidth]="10" [outerStrokeColor]="style.Circle"
                    [outerStrokeGradientStopColor]="style.Circle" [innerStrokeColor]="'#e7e8ea'" [innerStrokeWidth]="10"
                    [title]="'5/5'" [titleFontWeight]="600" [titleFontSize]="17" [showUnits]="false"
                    [showSubtitle]="false"></circle-progress>
                </div>
                <div style="padding-top: 40px">
                  <label class="uk-form-label"
                    style="font-size: 0.9rem !important; float: right; font-weight: bold; font-style: italic">ที่อยู่จัดส่งเอกสาร</label>
                  <br />
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; float: right; font-style: italic"></label>
                  <br />
                </div>
              </div>
              <div class="hline"></div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 1rem !important; font-weight: bold; font-style: italic">ที่อยู่ปัจจุบัน <span
                    style="font-size: 0.7rem !important; font-weight: lighter; font-style: normal">(กรมธรรม์เดิม)</span></label>
                <br />
                <br />
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">ที่อยู่<span
                    uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                    (click)="onEditAddr()"></span></label>
                <br />
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{insuredetail_data.address}}</label>
              </div>
              <div class="hline"></div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">เบอร์โทรศัพท์<span
                    uk-icon="file-edit" style="float: right; cursor: pointer; color: #3fbfb9;"
                    (click)="onEditTel()"></span></label>
                <br />
              </div>
              <div *ngIf="!editTel()">
                <label class="uk-form-label"
                  style="font-size: 0.8rem !important; font-weight: normal; word-wrap: break-word;">{{insuredetail_data.phoneNo}}</label>
              </div>
              <div *ngIf="editTel()">
                <div>
                  <input id="phone" #phone="ngModel" name="phone" class="uk-input uk-border-rounded" type="text"
                    placeholder="ระบุเบอร์โทรศัพท์" [(ngModel)]="phoneValue" (change)="onInputPhone($event)"
                    [ngClass]="addClass(renewForm,'phone')" mask="0000000009" required />
                </div>
                <br />
                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal"
                  style="padding-top: 0px; margin-top: 10px;">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; background-color: white;"
                    [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onCancelEditTel()">ยกเลิก
                  </button>
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right"
                    style="min-width: 140px !important; float: right" [ngStyle]="{'background-color': style.Button}"
                    (click)="onSaveTel()" [disabled]="renewForm.invalid">บันทึก
                  </button>
                </div>
              </div>

              <div style="padding: 0px 10px 0px 10px; background-color: #f4f4f4; line-height: 17px; margin-top: 30px;">
                <label class="uk-form-label" style="font-size: 0.7rem !important; color: red; word-wrap: break-word;">*
                  โปรดตรวจสอบข้อมูลของท่านให้เรียบร้อยก่อนยืนยันข้อมูล
                  เพราะท่านจะไม่สามารถกลับมาแก้ไขข้อมูลได้อีก</label>
              </div>
            </div>

            <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
              <button type="submit"
                class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px; background-color: white !important; border: 1px solid"
                [ngStyle]="{'border-color': style.Button, 'color': style.Button}" (click)="onNextToFourth()">ย้อนกลับ
              </button>
              <button type="submit"
                class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                style="width: 100%; margin: 1px !important; padding: 0px 0px 0px 0px;"
                [ngStyle]="{'background-color': style.Button}" (click)="onSubmit()">ยืนยันข้อมูล
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section uk-position-relative" uk-height-viewport *ngIf="form_fifth() && editAddr()">
      <div class="uk-container uk-container-xsmall uk-flex uk-flex-center">
        <div class="uk-width-1-2@s uk-border-rounded uk-overflow-hidden">
          <div class="uk-container uk-container-small" *ngIf="editAddr()">
            <div class="uk-card uk uk-card-body">
              <div class="uk-child-width-1-2" uk-grid>
                <div>
                  <label class="uk-form-label"
                    style="font-size: 1.2rem !important; font-weight: bold; font-style: italic">แก้ไขที่อยู่จัดส่ง</label>
                </div>
                <div>
                  <span uk-icon="close" style="cursor: pointer; float:right; color: black;"
                    (click)="onCancelEditAddr()"></span>
                </div>
              </div>
              <div class="hline"></div>
              <form autocomplete="off" #f201="ngForm" (keydown.enter)="$event.preventDefault()">
                <!-- สถานที่ จัดส่ง Start -->
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">สถานที่จัดส่ง
                    (เลขที่,อาคาร,ซอย,ถนน,แขวง)</label>
                </div>
                <div class="uk-form-controls uk-position-relative">
                  <input [ngClass]="addClass(f201,'address')" class="uk-input uk-border-rounded" name="address"
                    placeholder="ระบุสถานที่จัดส่ง" type="text" [(ngModel)]="addrValue1" required>
                  <small [ngClass]="addClass(f201,'address','msg')"
                    class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกสถานที่จัดส่ง
                    (เลขที่,อาคาร,ซอย,ถนน,แขวง)</small>
                </div>
                <!-- สถานที่ จัดส่ง End -->

                <!-- ตำบล Start -->
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">ตำบล / แขวง</label>
                </div>
                <div class="uk-form-controls uk-position-relative">
                  <input class="uk-input uk-border-rounded" type="hidden" placeholder="ตำบล / แขวงที่คุณอยู่" value=""
                    name="subDistrict" [(ngModel)]="model.address.current.subDistrict"
                    [ngClass]="addClass(f201,'subDistrict')" required />
                    <ng-autocomplete
                            [data]="results['current.subDistrict']"
                            [searchKeyword]="keyword"
                            (selected)="onSelect2($event,'subDistrict','current')"
                            (inputChanged)="onChangeSearch2($event,'subDistrict','current')"
                            (inputCleared)="onClearSelect()"
                            (inputFocused)='onFocused($event)'
                            [itemTemplate]="itemsubDistrict"
                            [notFoundTemplate]="notFoundTemplate"   
                            name="subDistrictText"            
                            [(ngModel)]="subDistrict"                            
                            [isLoading]="isLoading['current.subDistrict']"
                            placeholder="ตำบล / แขวง"
                            ></ng-autocomplete>
                            <ng-template #itemsubDistrict let-item>
                                <a [innerHTML]="item.markup"></a>
                                </ng-template>
                                
                                <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                                </ng-template>
                  <!-- <ng2-simple-autocomplete [(search)]="model.address.current.subDistrictText"
                    [ngClass]="addClass(f201,'subDistrict')" [(model)]="model.address.current.subDistrict"
                    [searchResults]="results['current.subDistrict']"
                    (onSelect)="onSelect2($event,'subDistrict','current')"
                    (onChangeInput)="onChangeSearch2($event,'subDistrict','current')" historyId="subDistrict"
                    placeholder="ตำบล / แขวง" [maxHistory]="10"></ng2-simple-autocomplete> -->
                  <small [ngClass]="addClass(f201,'subDistrict','msg')"
                    class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกตำบล /
                    แขวงที่คุณอยู่</small>
                </div>
                <!-- ตำบล end -->

                <!-- เขต/อำเภอ Start -->
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">เขต/อำเภอ</label>
                </div>
                <div class="uk-form-controls uk-position-relative">
                  <input class="uk-input uk-border-rounded" type="hidden" placeholder="อำเภอ / เขตที่คุณอยู่" value=""
                    name="district" [(ngModel)]="model.address.current.district" [ngClass]="addClass(f201,'district')"
                    required />
                    <ng-autocomplete
                                [ngClass]="addClass(f201,'district')"
                                [data]="results['current.district']"
                                [searchKeyword]="keyword"
                                (selected)="onSelect2($event,'district','current')"
                                (inputChanged)="onChangeSearch2($event,'district','current')"
                                (inputFocused)='onFocused($event)'
                                (inputCleared)="onClearSelect()"
                                [itemTemplate]="itemDistrict"
                                name="districtText"
                                [(ngModel)]="district"                                
                                [isLoading]="isLoading['current.district']"
                                placeholder="อำเภอ / เขต"
                                [notFoundTemplate]="notFoundTemplate"
                                ></ng-autocomplete>
                                <ng-template #itemDistrict let-item>
                                    <a [innerHTML]="item.markup"></a>
                                    </ng-template>
                                    
                                    <ng-template #notFoundTemplate let-notFound>
                                    <div [innerHTML]="notFound"></div>
                                    </ng-template>
                  <!-- <ng2-simple-autocomplete [ngClass]="addClass(f201,'district')"
                    [(search)]="model.address.current.districtText" [(model)]="model.address.current.district"
                    [searchResults]="results['current.district']" (onSelect)="onSelect2($event,'district','current')"
                    (onChangeInput)="onChangeSearch2($event,'district','current')"
                    [isLoading]="isLoading['current.district']" historyId="district" placeholder="อำเภอ / เขต"
                    [maxHistory]="0"></ng2-simple-autocomplete> -->

                  <small [ngClass]="addClass(f201,'district','msg')"
                    class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกอำเภอ
                    /
                    เขตที่คุณอยู่</small>
                </div>
                <!-- เขต/อำเภอ End -->

                <!-- จังหวัด Start -->
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">จังหวัด</label>
                </div>
                <div class="uk-form-controls uk-position-relative">
                  <input class="uk-input uk-border-rounded" type="hidden" id="province" placeholder="จังหวัดที่คุณอยู่"
                    value="" name="province2" [(ngModel)]="model.address.current.province"
                    [ngClass]="addClass(f201,'province')" required />
                    <ng-autocomplete
                                [ngClass]="addClass(f201,'province')"
                                [data]="results['current.province']"
                                [searchKeyword]="keyword"
                                (selected)="onSelect2($event,'province','current')"
                                (inputChanged)="onChangeSearch2($event,'province','current')"
                                (inputCleared)="onClearSelect()"
                                (inputFocused)='onFocused($event)'
                                [itemTemplate]="itemProvince"
                                name="provinceText"                                     
                                [(ngModel)]="province2"                                
                                [isLoading]="isLoading['current.province']"
                                placeholder="จังหวัด"
                                [notFoundTemplate]="notFoundTemplate"
                                ></ng-autocomplete>
                                <ng-template #itemProvince let-item>
                                    <a [innerHTML]="item.markup"></a>
                                    </ng-template>
                                    
                                    <ng-template #notFoundTemplate let-notFound>
                                    <div [innerHTML]="notFound"></div>
                                    </ng-template>
                  <!-- <ng2-simple-autocomplete [ngClass]="addClass(f201,'province')"
                    [(search)]="model.address.current.provinceText" [(model)]="model.address.current.province"
                    [searchResults]="results['current.province']" (onSelect)="onSelect2($event,'province','current')"
                    (onChangeInput)="onChangeSearch2($event,'province','current')"
                    [isLoading]="isLoading['current.province']" historyId="province" placeholder="จังหวัด"
                    [maxHistory]="0"></ng2-simple-autocomplete> -->

                  <small [ngClass]="addClass(f201,'province','msg')"
                    class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error">กรุณากรอกจังหวัดที่คุณอยู่</small>
                </div>
                <!-- จังหวัด End -->

                <!-- รหัสไปรษณีย์ Start -->
                <div>
                  <label class="uk-form-label"
                    style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">รหัสไปรษณีย์</label>
                </div>
                <div class="uk-form-controls uk-position-relative">
                  <input [ngClass]="addClass(f201,'postCode')" id="postCode1"
                    class="uk-input uk-border-rounded uk-text-emphasis" type="text" placeholder="รหัสไปรษณีย์"
                    maxlength="5" inputmode="decimal" [disabled]="true" name="postCode" #postCode="ngModel"
                    [(ngModel)]="model.address.current.postCode" [pattern]="regZipCode" required />
                  <small [ngClass]="addClass(f201,'postCode','msg')"
                    class="uk-text-danger uk-position-absolute uk-animation-fast uk-form-controls.error" tabindex="-1">
                    <span *ngIf="postCode.errors&&postCode.errors.required">กรุณาใส่รหัสไปรษณีย์</span>
                    <span *ngIf="postCode.errors&&postCode.errors.pattern">กรุณาใส่รหัสไปรษณีย์ให้ถูกต้อง</span>
                  </small>
                </div>

                <!-- รหัสไปรษณีย์ End -->

                <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
                  <button type="submit"
                    class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                    style="min-width: 300px !important;" [ngStyle]="{'background-color': style.Button}"
                    (click)="onSaveAddr(f201)">บันทึก
                  </button>
                </div>

              </form>


              <!-- <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">สถานที่จัดส่ง
                  (เลขที่,อาคาร,ซอย,ถนน,แขวง)</label>
              </div>
              <div>
                <input class="uk-input uk-border-rounded" placeholder="ระบุสถานที่จัดส่ง" type="text"
                  (change)="onInputAddr1($event)" require>
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">เขต/อำเภอ</label>
              </div>
              <div>
                <input class="uk-input uk-border-rounded" placeholder="ระบุเขต/อำเภอ" type="text" (change)="onInputAddr2($event)" require>
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">จังหวัด</label>
              </div>
              <div>
                <div class="uk-position-relative">
                  <select class="uk-select uk-border-rounded" (change)="onInputAddr3($event)" required>
                    <option value="">เลือกจังหวัด</option>
                    <option *ngFor="let data of insuredetail_data.province" [value]="data.value">{{data.detail}}</option>
                  </select>
                </div>
              </div>
              <div>
                <label class="uk-form-label"
                  style="font-size: 0.7rem !important; font-weight: bold; font-style: italic">รหัสไปรษณีย์</label>
              </div>
              <div>
                <input class="uk-input uk-border-rounded" placeholder="ระบุรหัสไปรษณีย์" type="text"
                  (change)="onInputAddr4($event)" require>
              </div> -->
            </div>

            <!-- <div class="uk-flex uk-flex-center uk-padding uk-padding-remove-horizontal">
              <button type="submit"
                class="uk-button uk-button-primary uk-border-rounded uk-margin-small-left uk-margin-small-right +btn-min-160"
                style="min-width: 300px !important;" (click)="onSaveAddr()">บันทึก
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </section>
  </form>
</div>

<app-loader *ngIf="loader()"></app-loader>